

<template>
  <div class="wx-login">
    <!-- Brand side -->
    <div class="wx-login-art">
      <div class="wx-login-brand"><span class="wx-login-logo">W</span><b>Worxspace</b></div>
      <h2>Όλη η δουλειά της ομάδας, σε ένα μέρος.</h2>
      <p>Projects, πελάτες, ώρες, άδειες και καμπάνιες — χωρίς να αλλάζεις εφαρμογή.</p>
    </div>
    <!-- Form side -->
    <div class="wx-login-form">
      <div class="form-container">
        <template v-if="!twoFactor">
          <h1 class="wx-login-title">Καλώς ήρθατε</h1>
          <p class="wx-login-sub">Συνδεθείτε στο λογαριασμό σας.</p>
        </template>
        <template v-else>
          <div class="wx-login-badge">🔐</div>
          <h1 class="wx-login-title">Επαλήθευση</h1>
          <p class="wx-login-sub">Πληκτρολογήστε τον κωδικό επιβεβαίωσης.</p>
        </template>
        <form @submit.prevent="login" @keydown.enter.prevent="login" method="POST">
          <div class="mb-3" v-if="twoFactor">
            <label class="form-label">Κωδικός επιβεβαίωσης</label>
            <input type="text" class="form-control login-email wx-otp" placeholder="_ _ _ _ _ _" name="twoFactor" v-model="twoFactorCode" autocomplete="one-time-code">
          </div>
          <div class="mb-3" v-if="!twoFactor">
            <label class="form-label">Email</label>
            <input type="email" class="form-control login-email" placeholder="name@example.com" name="username" v-model="username" autocomplete="username">
          </div>
          <div class="mb-3" v-if="!twoFactor">
            <label class="form-label d-flex justify-content-between align-items-center">
              <span>Κωδικός πρόσβασης</span>
              <a class="wx-login-link" @click.prevent="goToResetPassword()" href="#">Ξέχασα τον κωδικό μου.</a>
            </label>
            <div class="position-relative">
              <input id="showPassword" type="password" v-model="password" class="form-control login-password" placeholder="********" autocomplete="current-password">
              <span class="showPasswordIcon" @click="showPass()"><i class="icofont-eye-alt"></i></span>
            </div>
          </div>
          <div class="form-check mb-1" v-if="!twoFactor">
            <input class="form-check-input" type="checkbox" v-model="remember_me" id="flexCheckDefault">
            <label class="form-check-label" for="flexCheckDefault">Nα με θυμάσαι</label>
          </div>

          <button class="wx-login-btn" v-if="!twoFactor" @click="login">Σύνδεση</button>
          <button class="wx-login-btn btn-validate-2fa-code" v-if="twoFactor" @click="verifyCode">Επαλήθευση</button>

          <div class="error-div mt-3 text-danger" v-if="errorMessage">
            <p>{{ errorMessage }}</p>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>


<script>
import { onMounted, onUnmounted } from 'vue';
import { login as authLogin } from '../services/auth.js';
import apiClient from '@/services/api.js';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      remember_me: false,
      errorMessage: null,
      twoFactor: false,
      twoFactorCode: '',
      browserFingerprint: null,
    };
  },
  setup() {
    const handleKeyPressed = (event) => {
      if (event.key === 'Enter') {
        $('.btn-login').trigger('click');
      }
    };

    onMounted(() => {
      document.addEventListener('keyup', handleKeyPressed);
    });

    onUnmounted(() => {
      document.removeEventListener('keyup', handleKeyPressed);
    });
  },
  async mounted() {
    // Load the FingerprintJS agent
    const fp = await FingerprintJS.load();

    // Get the fingerprint data asynchronously
    const result = await fp.get();
    this.browserFingerprint = result.visitorId;  // Save the browser fingerprint
  },
  methods: {
    goToResetPassword() {
      this.$router.push('/reset-password');
    },
    async send2faVerificationCode() {
      const response = await apiClient.post('/send-2fa-code', {
        username: this.username,
        password: this.password,
        b_id: this.browserFingerprint // Use the browser fingerprint here
      });
      return response.data.success;
    },
    async login() {
      this.errorMessage = null;
      if (this.username && this.password) {
        try {
          const response = await authLogin(this.username, this.password, this.browserFingerprint, this.remember_me);
          if (response.data?.success) {
            if (response.data.data['2fa'] && !this.twoFactor) {
              this.twoFactor = true;
              const codeSent = await this.send2faVerificationCode();
              if (!codeSent) {
                this.errorMessage = "Failed to send 2FA code";
              }
            } else if (response.data?.data?.token?.plainTextToken) {
              localStorage.setItem('api_token', response.data?.data?.token?.plainTextToken);
              localStorage.setItem('current_user_id', response.data?.data.info.id);
              const redirectAfterLogin = sessionStorage.getItem('redirectAfterLogin');
              if (redirectAfterLogin) {
                window.location.href = redirectAfterLogin;
                sessionStorage.removeItem('redirectAfterLogin'); // Clear the redirect data
              } else {
const packets = response.data?.data.info.packets || [];

if(response.data?.data.info.isAccountant === 1){
this.$router.push('/accountant-dashboard');
}else{
 if (packets.includes('PROJECT MANAGEMENT')) {
      this.$router.push('/projects');
    } else if (packets.includes('HR') || packets.includes('CRM')) {
      this.$router.push('/users');
    } else {
      this.$router.push('/'); // fallback
    }  
}

               }
            }
          } else {
            if(response.data.message === "Wrong credentials"){
               this.errorMessage = response.data.message;
            }
          }
        } catch (e) {
          this.errorMessage = "Λάθος στοιχεία σύνδεσης";
        }
      }
    },
    async verifyCode() {
      try {
        const response = await apiClient.post('/validate-2fa-code', {
          username: this.username,
          password: this.password,
          remember_me: this.remember_me ? 1 : 0,
          code: this.twoFactorCode,
          b_id: this.browserFingerprint // Use the browser fingerprint here
        });
        if (response.data.success) {
          // Manually set the cookie
          const token = response.data.data.token;
          const prefix = response.data.data.prefix;
          const expires = new Date();
          expires.setTime(expires.getTime() + 7 * 24 * 60 * 60 * 1000); // 7 days expiration time
          
          // Setting the cookie
          document.cookie = `${prefix}=${token}; expires=${expires.toUTCString()}; path=/; secure`;

          setTimeout(this.login, 500);
        } else {
          this.errorMessage = response.data.message;
        }
      } catch (error) {
        this.errorMessage = "Verification failed";
      }
    },
    showPass() {
      const passField = document.getElementById('showPassword');
      passField.type = passField.type === 'password' ? 'text' : 'password';
    }
  }
};
</script>

<style scoped>
.wx-login { min-height: 100vh; width: 100%; display: grid; grid-template-columns: 1.1fr 1fr; gap: 14px; padding: 14px; }
.wx-login-art { border-radius: 28px; background: var(--wx-g-proj); color: #fff; padding: 40px; display: flex; flex-direction: column; position: relative; overflow: hidden; }
.wx-login-art::before { content: ""; position: absolute; width: 520px; height: 520px; border-radius: 50%; background: rgba(255,255,255,.1); right: -160px; top: -140px; }
.wx-login-art::after { content: ""; position: absolute; width: 360px; height: 360px; border-radius: 50%; background: rgba(255,255,255,.08); left: -100px; bottom: -120px; }
.wx-login-brand { display: flex; align-items: center; gap: 10px; font-size: 18px; position: relative; z-index: 1; }
.wx-login-logo { width: 42px; height: 42px; border-radius: 14px; background: #fff; color: var(--wx-accent); display: grid; place-items: center; font-weight: 800; font-size: 17px; }
.wx-login-art h2 { font-size: 40px; font-weight: 800; letter-spacing: -.03em; line-height: 1.1; margin-top: auto; color: #fff; position: relative; z-index: 1; }
.wx-login-art p { color: #fff !important; opacity: .9; margin-top: 12px; max-width: 420px; position: relative; z-index: 1; }
.wx-login-form { background: var(--wx-card); border-radius: 28px; display: grid; place-items: center; padding: 30px; }
.form-container { width: 100%; max-width: 380px; }
.wx-login-title { font-size: 30px; font-weight: 800; letter-spacing: -.03em; color: var(--wx-text); margin: 0; }
.wx-login-sub { color: var(--wx-text-3); margin: 6px 0 26px; }
.wx-login-badge { width: 48px; height: 48px; border-radius: 16px; background: color-mix(in srgb, var(--wx-accent) 14%, transparent); display: grid; place-items: center; font-size: 22px; margin-bottom: 14px; }
.wx-login-link { color: var(--wx-accent) !important; font-weight: 500; font-size: 12.5px; }
.form-control { height: 48px; }
.wx-otp { font-size: 22px; font-weight: 800; letter-spacing: .5em; text-align: center; }
.showPasswordIcon { position: absolute; right: 14px; top: 50%; transform: translateY(-50%); cursor: pointer; color: var(--wx-text-3); }
.wx-login-btn { width: 100%; height: 48px; margin-top: 18px; border: 0; border-radius: 14px; background: var(--wx-g-proj); color: #fff; font-weight: 700; font-size: 15px; box-shadow: 0 6px 18px rgba(109, 93, 252, .35); transition: transform .15s, box-shadow .15s; }
.wx-login-btn:hover { transform: translateY(-1px); box-shadow: 0 10px 24px rgba(109, 93, 252, .45); }
@media (max-width: 900px) { .wx-login { grid-template-columns: 1fr; } .wx-login-art { display: none; } }
</style>
